// Preset options for Vuetify
// Preset refs: https://vuetifyjs.com/en/features/presets/
// Examples: https://github.com/vuetifyjs/vue-cli-plugins/tree/master/packages/%40vuetify/material-studies/templates
require('./overrides.scss')

const preset = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        primary: '#DF348F',
        'primary-2': '#6A2FAD',
        secondary: '#EE6641',
        'secondary-2': '#6457E3',
        accent: '#FE55A9', // primary-lighten1
        black: '#333',
        white: '#FFF',
        twilight: '#606272',
        midnight: '#6E7083',
        daylight: '#B4B9D6',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FB8C00'
      }
    }
  },
  icons: {
    iconfont: 'fa'
  }
}

module.exports = { preset }
